import React, { useEffect, useMemo, useState } from "react";
import { MwButton, MwInputText, MwSpinnerButton, MwSelector } from "../ui";
import { useFetch } from "../../hooks";
import { useTranslation } from "react-i18next";

const CreatePaymentMethod = ({
  currentLangList,
  currentTenantId,
  currentCompanyId,
  currentBranchId,
  currentLangId,
  userId,
  data,
  postData,
  loading,
}) => {
  const [namepaymentMethod, setNamepaymentMethod] = useState({});
  const [despaymentMethod, setDescpaymentMethod] = useState({});
  const [treasurySelected, setTreasurySelected] = useState("");
  const financeBaseUrl = useMemo(() => {
    if (process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL) {
      return process.env.REACT_APP_FINANCE_API_SERVER_BASE_URL.replace(
        /\/+$/,
        "",
      );
    }
    if (process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL) {
      return process.env.REACT_APP_INV_API_SALES_SERVER_BASE_URL.replace(
        /\/sales\/?$/,
        "/finance",
      ).replace(/\/+$/, "");
    }
    return `${(process.env.REACT_APP_API_URL || "").replace(/\/+$/, "")}/finance`;
  }, []);
  const { data: treasuriesResult } = useFetch(
    `${financeBaseUrl}/treasuries/${currentTenantId}/${currentCompanyId}/${currentBranchId}`,
  );
  const [treasuriesList, setTreasuriesList] = useState([]);
  const [tabLang, setTabLang] = useState("en");
  const [t] = useTranslation("global");

  const tabLangHandler = (newValue) => {
    setTabLang(newValue);
  };

  const submitHandler = (e) => {
    e.preventDefault();
    if (
      Object.keys(namepaymentMethod).length === 0 &&
      Object.keys(despaymentMethod).length === 0
    )
      return;
    let description = [];

    currentLangList.map((lang) => {
      if (!namepaymentMethod[lang.langCode] && !despaymentMethod[lang.langCode])
        return;
      description = [
        ...description,
        {
          name: namepaymentMethod[lang.langCode],
          desc: despaymentMethod[lang.langCode],
          lang: lang.langCode,
        },
      ];
    });
    const _data = {
      isActive: true,
      tenantId: currentTenantId,
      companyId: currentCompanyId,
      branchId: currentBranchId,
      createdBy: userId,
      treasurie_id: treasurySelected?.value || "",
      description: description,
    };
    console.log(_data);
    postData(
      `${process.env.REACT_APP_INV_API_SERVER_BASE_URL}/payment-methods`,
      _data,
    );
  };

  useEffect(() => {
    if (!!data && !loading) {
      setNamepaymentMethod({});
      setDescpaymentMethod({});
      setTreasurySelected("");
    }
  }, [data]);

  useEffect(() => {
    if (!treasuriesResult?.data) return;
    const list = treasuriesResult.data.map((item) => ({
      label: currentLangId === "ar" ? item.name_ar : item.name_en,
      value: item.id,
      lang: currentLangId,
    }));
    setTreasuriesList(list);
  }, [treasuriesResult, currentLangId]);

  return (
    <div>
      <div className="text-sm font-bold pb-3" style={{ color: "#251658" }}>
        {t("setting.paymentMethodSettings")}
      </div>
      <div
        className="p-3 rounded-lg border"
        style={{ borderColor: "#251658", backgroundColor: "#f8f7fc" }}
      >
        <form onSubmit={submitHandler}>
          <div className="flex justify-between items-center">
            <div
              className="text-xs py-2 font-semibold"
              style={{ color: "#251658" }}
            >
              {t("setting.create")}
            </div>
            {loading ? (
              <MwSpinnerButton />
            ) : (
              <MwButton inGroup={true} size="sm" type="saveBtn">
                {" "}
                {t("common.save")}
              </MwButton>
            )}
          </div>
          <div className="flex gap-2 mt-3 text-xs">
            {currentLangList.map((lang) => (
              <div
                key={lang._id}
                onClick={() => tabLangHandler(lang.langCode)}
                className={` cursor-default px-2 py-1 rounded ${tabLang === lang.langCode ? "font-semibold" : ""}`}
                style={{
                  color: tabLang === lang.langCode ? "#251658" : "#666",
                }}
              >
                {lang.langName}
              </div>
            ))}
          </div>
          <div className="flex flex-col gap-3 py-2  md:flex-row md:gap-0  ">
            {currentLangList.map((lang) => {
              return (
                <div
                  key={lang._id}
                  className={` flex flex-col gap-2 flex-1 ${tabLang === lang.langCode ? "block" : "hidden"} `}
                >
                  <div>
                    <MwInputText
                      placeholder={t("setting.enter_method_name")}
                      size="sm"
                      value={namepaymentMethod[lang.langCode]}
                      onChange={(e) =>
                        setNamepaymentMethod({
                          ...namepaymentMethod,
                          [lang.langCode]: e.target.value,
                        })
                      }
                    />
                  </div>
                  <div>
                    <MwInputText
                      placeholder={t("setting.enter_method_desc")}
                      size="sm"
                      value={despaymentMethod[lang.langCode]}
                      onChange={(e) =>
                        setDescpaymentMethod({
                          ...despaymentMethod,
                          [lang.langCode]: e.target.value,
                        })
                      }
                    />
                  </div>
                </div>
              );
            })}
          </div>
          <div className="pt-2">
            <MwSelector
              label={t("invoice.Treasury")}
              initalValue={t("invoice.selectTreasury")}
              dataType="labelValue"
              _data={treasuriesList}
              withAddNew={false}
              withSearch={true}
              selectedItem={treasurySelected}
              setSelectedItem={setTreasurySelected}
            />
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreatePaymentMethod;
